import { Divider, Stack, TableCell, Typography } from "@mui/material";
import { FC, memo, useCallback, useMemo } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store";
import { setPopUpRota } from "../../store/root";
import { getRotaWhiteCache } from "../../lib/white-cache";
import { nanoid } from "nanoid";

interface CellInterface {
  calendarType: string;
  id: string;
  date: Date;
  userName?: string;
  userId?: string;
  shift: {
    extraId?: string;
    startTime1?: string;
    startTime2?: string;
    endTime1?: string;
    endTime2?: string;
    isHoliday?: boolean;
    isExtra?: boolean;
    isClosed?: boolean;
    isInitial?: boolean;
  };
  calendar: {
    extraId?: string;
    startTime1?: string;
    startTime2?: string;
    endTime1?: string;
    endTime2?: string;
    isHoliday?: boolean;
    isExtra?: boolean;
    isClosed?: boolean;
    isInitial?: boolean;
  };
  defaultShift?: {
    startTime1?: string;
    startTime2?: string;
    endTime1?: string;
    endTime2?: string;
  };
  defaultCalendar?: {
    startTime1?: string;
    startTime2?: string;
    endTime1?: string;
    endTime2?: string;
  };

  isSingleCalendarManagement: boolean;
}

export const DoubleCell: FC<CellInterface> = memo(
  ({
    calendarType,
    userId,
    userName,
    id,
    date,
    shift,
    calendar,
    defaultShift,
    defaultCalendar,
    isSingleCalendarManagement,
  }) => {
    const { turniFilter } = useSelector((state: RootState) => state.rotaRoot);
    const dispatch = useDispatch<AppDispatch>();
    const { turniModifica } = getRotaWhiteCache();

    const GetContent = ({ turno }: any) => {
      const {
        startTime1,
        startTime2,
        endTime1,
        endTime2,
        isHoliday = false,
        isExtra = false,
        isClosed = false,
        isInitial = false,
      } = turno;
      if (isInitial)
        return (
          <Stack
            gap={1}
            flex="1"
            sx={{
              height: "69px",
            }}
            justifyContent="center"
          ></Stack>
        );
      if (isHoliday)
        return (
          <Stack
            gap={1}
            flex="1"
            sx={{
              // background:
              //   "repeating-linear-gradient( -45deg, #00000030, #00000030 5px, #00000050 5px, #00000050 10px )",
              height: "69px",
              opacity: 0.5,

              background: "var(--closed-color)",
            }}
            justifyContent="center"
          >
            {/* <ClearIcon
              sx={{
                color: "#ffffff!important",
                width: "40px",
                height: "40px",
                margin: "auto",
              }}
            /> */}
          </Stack>
        );
      if (isExtra) {
        if (isClosed) {
          return (
            <Stack
              gap={1}
              flex="1"
              sx={{
                // background: "var(--accent-pressed-color)",
                border: "1px solid var(--accent-pressed-color)",
                boxSizing: "border-box",
                background: "#de5c5c30",
                // background:
                //   "repeating-linear-gradient( -45deg, var(--accent-color),var(--accent-color) 5px, var(--accent-pressed-color) 5px, var(--accent-pressed-color) 10px )",
                height: "69px",
                color: "white",
              }}
              justifyContent="center"
            >
              {/* <ClearIcon
                sx={{
                  // color: "#ffffff!important",
                  width: "15px",
                  height: "15px",
                  margin: "auto",
                }}
              /> */}
            </Stack>
          );
        } else
          return (
            <Stack
              // gap={1}
              flex="1"
              sx={{
                // backgroundColor: "var(--accent-pressed-color)",
                border: "1px solid #1375c0",
                boxSizing: "border-box",
                background: "#1375c020",
                // color: "white",
                height: "69px",
              }}
              justifyContent="center"
            >
              <Typography fontWeight="bold">
                {startTime1 && endTime1 ? `${startTime1} - ${endTime1}` : "-"}
              </Typography>
              <Typography fontWeight="bold">
                {startTime2 && endTime2 ? `${startTime2} - ${endTime2}` : "-"}
              </Typography>
            </Stack>
          );
      }
      if (isClosed)
        return (
          <Stack
            gap={1}
            flex="1"
            sx={{
              background: "var(--closed-color)",
              opacity: 0.5,
              height: "69px",
              zIndex: 0,
            }}
            justifyContent="center"
          >
            {/* <Typography fontWeight="bold">{"-"}</Typography>
            <Typography fontWeight="bold">{"-"}</Typography> */}
            <ClearIcon
              sx={{
                // color: "#ffffff!important",
                width: "15px",
                height: "15px",
                margin: "auto",
              }}
            />
          </Stack>
        );

      return (
        <Stack
          flex="1"
          sx={{
            height: "69px",
          }}
          justifyContent="center"
        >
          <Typography>
            {startTime1 && endTime1 ? `${startTime1} - ${endTime1}` : "-"}
          </Typography>
          <Typography>
            {startTime2 && endTime2 ? `${startTime2} - ${endTime2}` : "-"}
          </Typography>
        </Stack>
      );
    };

    const ShiftComponent = useMemo(() => {
      if (turniFilter === "calendar" || isSingleCalendarManagement)
        return <></>;
      return <GetContent turno={shift} />;
    }, [isSingleCalendarManagement, shift, turniFilter]);

    const CalendarComponent = useMemo(() => {
      if (turniFilter === "shift") return <></>;
      return <GetContent turno={calendar} />;
    }, [calendar, turniFilter]);

    const handleClick = useCallback(() => {
      if (turniModifica)
        dispatch(
          setPopUpRota({
            id: id,
            userId: userId,
            userName: userName,
            date: date,
            calendarType: calendarType as any,
            shift: shift as any,
            calendar: calendar as any,
            defaultCalendar,
            defaultShift,
          })
        );
    }, [
      calendar,
      calendarType,
      date,
      defaultCalendar,
      defaultShift,
      dispatch,
      id,
      shift,
      turniModifica,
      userId,
      userName,
    ]);

    return (
      <TableCell
        key={nanoid()}
        align="center"
        // rowSpan={
        //   turniFilter !== undefined || isSingleCalendarManagement ? 1 : 2
        // }
        style={{
          padding: 0,
          margin: 0,
          height:
            isSingleCalendarManagement || turniFilter !== undefined
              ? "70px"
              : "140px",
          cursor: turniModifica ? "pointer" : "default",
          boxSizing: "border-box",
          borderBottom: "1px solid var(--divider-color)",
          borderRight: "1px solid var(--divider-color)",
        }}
        onClick={handleClick}
      >
        <Stack
          flex="1"
          sx={{
            boxSizing: "border-box",
            p: 0,
            height:
              isSingleCalendarManagement || turniFilter !== undefined
                ? "70px"
                : "140px",
            "&:hover": {
              border: turniModifica ? "1px solid black" : undefined,
            },
          }}
        >
          {ShiftComponent}
          {turniFilter === undefined && !isSingleCalendarManagement && (
            <Divider sx={{ borderColor: "var(--divider-color)" }} />
          )}
          {CalendarComponent}
        </Stack>
      </TableCell>
    );
  }
);
